export default "__VITE_ASSET__9f70ea5b__"